export const NOTIFICATIONS_DATA_REQUEST = 'NOTIFICATIONS_DATA_REQUEST';
export const NOTIFICATIONS_DATA_SUCCESS = 'NOTIFICATIONS_DATA_SUCCESS';
export const NOTIFICATIONS_DATA_FAIL = 'NOTIFICATIONS_DATA_FAIL';